import { Component } from "react";
import { NotFoundPic } from "../../../assets";
import { Button } from "../../components/button";
import { Helmet } from "react-helmet-async";
import routes from "../../../core/routes";
class NotFound extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div className="not-found">
                <Helmet>
        <title> 404 | صفحه مورد نظر پیدا نشد</title>
      </Helmet>
                <div className="not-found-content">
                    <img src={NotFoundPic} className="content-img" alt="هامرز"/>

                    <span className="content-title">
                        صفحه مورد نظر شما پیدا نشد
                    </span>
                    <p className="content-desc">
                        صفحه مورد نظر شما پیدا نشد لطفا مجددا تلاش نمایید
                    </p>
                    <p className="content-desc">
                        در صورت تکرار مجدد با تیم پشتیبانی جهت رفع مشکل اطلاع دهید
                    </p>
                    <Button onClick={() => window.location.href = `${routes.INSURANCERATE}`} myStyle="bg-light-blue content-btn" title="بازگشت به صفحه اصلی" />
                </div>
            </div>
        )
    }
}
export default NotFound;